import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";
import { BRANCHES } from "@/lib/constants";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    });
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      const sub = await (await navigator.serviceWorker?.getRegistration())?.pushManager.getSubscription();
      if (sub) {
        await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
        await sub.unsubscribe();
      }
    } catch (_) {}
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  const can = (perm) => !!user && user.role === "admin" && (user.is_owner || (user.permissions || []).includes(perm));
  const branches = user && !user.is_owner && user.branches?.length ? user.branches : BRANCHES;

  return <AuthCtx.Provider value={{ user, login, logout, can, branches }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
